/**
 * Check if IntersectionObserver is natively enabled.
 * @return {Boolean} Returns true if IntersectionObserver is enabled, false otherwise.
 */
export const isIntersectionObserverEnabled = () => 'IntersectionObserver' in window;
